import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import cx from 'classnames';
import SwapOpenIcon from '@mui/icons-material/SwapHoriz';
import SwapCloseIcon from '@mui/icons-material/Close';
import ExpandOpenIcon from '@mui/icons-material/ExpandMore';
import ExpandCloseIcon from '@mui/icons-material/ExpandLess';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import { ListItemSecondaryAction, IconButton, Collapse, Tooltip, List, Popover } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SelectableItemList, { SelectableItemLabel } from '../SelectableItemList';
import { BEHAVIOR, HEIGHT, VARIANT } from './constants';
const useStyles = makeStyles(({
  spacing
}) => ({
  buttonIcon: {
    pointerEvents: 'none'
  },
  buttonContainer: {
    paddingTop: spacing(2),
    paddingBottom: spacing(2)
  },
  itemContainer: {
    width: '100%',
    position: 'relative',
    top: spacing(-1)
  },
  compactContainer: {
    maxHeight: 240
  },
  tooltipChild: {
    width: '100%',
    paddingRight: spacing(4)
  }
}), {
  classNamePrefix: 'ContextSwitcher'
});
export default function ContextSwitcher(t0) {
  const $ = _c(69);
  const {
    beforeNode: t1,
    afterNode: t2,
    selectedItem: t3,
    items: t4,
    pinnedItems: t5,
    variant: t6,
    behavior: t7,
    onChange: t8,
    onOpen: t9,
    onClose: t10,
    onOpened: t11,
    onClosed: t12,
    size: t13,
    listComponent: t14,
    ariaLabelClose: t15
  } = t0;
  const beforeNode = t1 === undefined ? null : t1;
  const afterNode = t2 === undefined ? null : t2;
  const selectedItem = t3 === undefined ? null : t3;
  let t16;
  if ($[0] !== t4) {
    t16 = t4 === undefined ? [] : t4;
    $[0] = t4;
    $[1] = t16;
  } else {
    t16 = $[1];
  }
  const items = t16;
  let t17;
  if ($[2] !== t5) {
    t17 = t5 === undefined ? [] : t5;
    $[2] = t5;
    $[3] = t17;
  } else {
    t17 = $[3];
  }
  const pinnedItems = t17;
  const variant = t6 === undefined ? VARIANT.SWAP : t6;
  const behavior = t7 === undefined ? BEHAVIOR.POPIN : t7;
  const onChange = t8 === undefined ? _temp : t8;
  const onOpen = t9 === undefined ? _temp2 : t9;
  const onClose = t10 === undefined ? _temp3 : t10;
  const onOpened = t11 === undefined ? _temp4 : t11;
  const onClosed = t12 === undefined ? _temp5 : t12;
  const size = t13 === undefined ? HEIGHT.UNSET : t13;
  const ListComponent = t14 === undefined ? List : t14;
  const ariaLabelClose = t15 === undefined ? "Close" : t15;
  const [isOpen, toggleOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  let t18;
  if ($[4] !== onOpen) {
    t18 = target => {
      setAnchorEl(target);
      toggleOpen(true);
      onOpen();
    };
    $[4] = onOpen;
    $[5] = t18;
  } else {
    t18 = $[5];
  }
  const openSwitcher = t18;
  let t19;
  if ($[6] !== onClose) {
    t19 = () => {
      setAnchorEl(null);
      toggleOpen(false);
      onClose();
    };
    $[6] = onClose;
    $[7] = t19;
  } else {
    t19 = $[7];
  }
  const closeSwitcher = t19;
  let t20;
  if ($[8] !== closeSwitcher || $[9] !== isOpen || $[10] !== openSwitcher) {
    t20 = e => {
      if (isOpen) {
        closeSwitcher();
      } else {
        openSwitcher(e.currentTarget);
      }
    };
    $[8] = closeSwitcher;
    $[9] = isOpen;
    $[10] = openSwitcher;
    $[11] = t20;
  } else {
    t20 = $[11];
  }
  const onButtonClick = t20;
  let t21;
  if ($[12] !== closeSwitcher || $[13] !== onChange) {
    t21 = item => {
      onChange(item);
      closeSwitcher();
    };
    $[12] = closeSwitcher;
    $[13] = onChange;
    $[14] = t21;
  } else {
    t21 = $[14];
  }
  const onItemSelected = t21;
  const classes = useStyles();
  const selectedItemLabel = selectedItem?.label;
  const selectedItemValue = selectedItem?.value;
  let t22;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      swap: {
        open: <SwapOpenIcon />,
        close: <SwapCloseIcon />
      },
      expand: {
        open: <ExpandOpenIcon />,
        close: <ExpandCloseIcon />
      }
    };
    $[15] = t22;
  } else {
    t22 = $[15];
  }
  const variantToIcons = t22;
  const icons = variantToIcons[variant];
  let t23;
  if ($[16] !== ListComponent || $[17] !== onItemSelected || $[18] !== pinnedItems || $[19] !== selectedItemValue || $[20] !== size) {
    t23 = Boolean(pinnedItems.length) && <SelectableItemList items={pinnedItems} listComponent={ListComponent} selectedItemValue={selectedItemValue} onChange={onItemSelected} size={size} />;
    $[16] = ListComponent;
    $[17] = onItemSelected;
    $[18] = pinnedItems;
    $[19] = selectedItemValue;
    $[20] = size;
    $[21] = t23;
  } else {
    t23 = $[21];
  }
  const pinnedItemList = t23;
  let t24;
  if ($[22] !== ListComponent || $[23] !== afterNode || $[24] !== items || $[25] !== onItemSelected || $[26] !== selectedItemValue || $[27] !== size) {
    t24 = Boolean(items.length) && <SelectableItemList items={items} listComponent={ListComponent} selectedItemValue={selectedItemValue} onChange={onItemSelected} size={size}>{afterNode}</SelectableItemList>;
    $[22] = ListComponent;
    $[23] = afterNode;
    $[24] = items;
    $[25] = onItemSelected;
    $[26] = selectedItemValue;
    $[27] = size;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  const itemList = t24;
  let t25;
  if ($[29] !== beforeNode || $[30] !== itemList || $[31] !== pinnedItemList) {
    t25 = <>{beforeNode}{pinnedItemList}{itemList}</>;
    $[29] = beforeNode;
    $[30] = itemList;
    $[31] = pinnedItemList;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  const children = t25;
  const t26 = size === HEIGHT.COMPACT;
  let t27;
  if ($[33] !== classes.compactContainer || $[34] !== t26) {
    t27 = cx({
      [classes.compactContainer]: t26
    });
    $[33] = classes.compactContainer;
    $[34] = t26;
    $[35] = t27;
  } else {
    t27 = $[35];
  }
  const t28 = !selectedItemLabel ? "" : selectedItemLabel;
  const t29 = selectedItemLabel || "...";
  let t30;
  if ($[36] !== t29) {
    t30 = <SelectableItemLabel variant="h6">{t29}</SelectableItemLabel>;
    $[36] = t29;
    $[37] = t30;
  } else {
    t30 = $[37];
  }
  let t31;
  if ($[38] !== classes.tooltipChild || $[39] !== t30) {
    t31 = <div className={classes.tooltipChild}>{t30}</div>;
    $[38] = classes.tooltipChild;
    $[39] = t30;
    $[40] = t31;
  } else {
    t31 = $[40];
  }
  let t32;
  if ($[41] !== t28 || $[42] !== t31) {
    t32 = <Tooltip title={t28} enterDelay={500}>{t31}</Tooltip>;
    $[41] = t28;
    $[42] = t31;
    $[43] = t32;
  } else {
    t32 = $[43];
  }
  const t33 = isOpen && ariaLabelClose;
  const t34 = isOpen ? icons.close : icons.open;
  let t35;
  if ($[44] !== t33 || $[45] !== t34) {
    t35 = <IconButton edge="end" size="small" color="inherit" tabIndex={-1} aria-label={t33}>{t34}</IconButton>;
    $[44] = t33;
    $[45] = t34;
    $[46] = t35;
  } else {
    t35 = $[46];
  }
  let t36;
  if ($[47] !== classes.buttonIcon || $[48] !== t35) {
    t36 = <ListItemSecondaryAction className={classes.buttonIcon}>{t35}</ListItemSecondaryAction>;
    $[47] = classes.buttonIcon;
    $[48] = t35;
    $[49] = t36;
  } else {
    t36 = $[49];
  }
  let t37;
  if ($[50] !== classes.buttonContainer || $[51] !== onButtonClick || $[52] !== t32 || $[53] !== t36) {
    t37 = <ListItemButton component="li" onClick={onButtonClick} className={classes.buttonContainer}>{t32}{t36}</ListItemButton>;
    $[50] = classes.buttonContainer;
    $[51] = onButtonClick;
    $[52] = t32;
    $[53] = t36;
    $[54] = t37;
  } else {
    t37 = $[54];
  }
  let t38;
  if ($[55] !== anchorEl || $[56] !== behavior || $[57] !== children || $[58] !== classes.itemContainer || $[59] !== closeSwitcher || $[60] !== isOpen || $[61] !== onClosed || $[62] !== onOpened) {
    t38 = behavior === BEHAVIOR.PUSH ? <Collapse in={isOpen} component={ListItem} disableGutters={true} classes={{
      wrapper: classes.itemContainer
    }} unmountOnExit={true} data-testid={BEHAVIOR.PUSH} onEntered={onOpened} onExited={onClosed}>{children}</Collapse> : <Popover open={isOpen} anchorEl={anchorEl} onClose={closeSwitcher} anchorOrigin={{
      vertical: "bottom",
      horizontal: "left"
    }} transformOrigin={{
      vertical: "top",
      horizontal: "left"
    }} data-testid={BEHAVIOR.POPIN} TransitionProps={{
      unmountOnExit: true,
      onEntered: onOpened,
      onExited: onClosed
    }}>{children}</Popover>;
    $[55] = anchorEl;
    $[56] = behavior;
    $[57] = children;
    $[58] = classes.itemContainer;
    $[59] = closeSwitcher;
    $[60] = isOpen;
    $[61] = onClosed;
    $[62] = onOpened;
    $[63] = t38;
  } else {
    t38 = $[63];
  }
  let t39;
  if ($[64] !== ListComponent || $[65] !== t27 || $[66] !== t37 || $[67] !== t38) {
    t39 = <ListComponent className={t27}>{t37}{t38}</ListComponent>;
    $[64] = ListComponent;
    $[65] = t27;
    $[66] = t37;
    $[67] = t38;
    $[68] = t39;
  } else {
    t39 = $[68];
  }
  return t39;
}
function _temp5() {}
function _temp4() {}
function _temp3() {}
function _temp2() {}
function _temp() {}